import { CLIENT } from '../config';

export enum Clients {
  Incrowd = 'apollo',
  Netquest = 'netquest',
  PureProfile = 'pureprofile',
}

export const isIncrowdClient = (): boolean => {
  return CLIENT === Clients.Incrowd;
};

export const isNetquestClient = (): boolean => Clients.Netquest === CLIENT;

export const isPureProfileClient = (): boolean => CLIENT === Clients.PureProfile;

export const isExternalClient = (): boolean => isNetquestClient() || isPureProfileClient();
